import { useQuery } from '@tanstack/react-query';
import { getDmNotes, type DmNotes } from '../services/dmNotes';
import { DM_NOTES_KEY } from './queryKeys';

export function useDmNotes(patientId: string | undefined) {
    const { data, error, isLoading, refetch } = useQuery<DmNotes>({
        queryKey: DM_NOTES_KEY(patientId),
        queryFn: () => getDmNotes(patientId!),
        enabled: !!patientId,
        staleTime: 2 * 60 * 1000
    });

    return { data: data ?? null, isLoading, error, refetch };
}
